module.exports = __webpack_public_path__ + "static/media/welcomepage2.c2ce6b64.png";